RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const FilterPill = Marionette.ItemView.mixin({
        className: 'filter-pill',
        template: '#filterPillTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            deleteBtn: '.x-delete-filter'
        },

        events: {
            'click @ui.deleteBtn': 'onDelete'
        },

        serializeData: function () {
            const me = this;

            const filterDimension = me.model.get('filterDimension');
            let value = me.model.get('value');
            if (filterDimension.id === 'hashtag') {
                value = `#${value}`;
            }

            return {
                filterDimensionName: filterDimension.name,
                value: value
            };
        },

        onDelete: function () {
            const me = this;

            const filterPropName = `${me.model.get('filterDimension').id}Filters`;
            const newValue = _.without(me.getProp(filterPropName), me.model.get('value'));
            me.setProps(filterPropName, newValue);
        }
    });

    views.FilterPills = RivalIQ.views.CollectionView.mixin({
        className: 'filter-pills',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childView: FilterPill,

        initialize: function () {
            const me = this;
            me.collection = new Backbone.Collection();
        },

        childViewOptions: function () {
            const me = this;

            return {
                dashboardModel: me.dashboardModel
            };
        },

        onBeforeRender: function () {
            const me = this;

            const filters = _.reduce(App.enums.filterableDimensions, function (memo, filterDimension) {
                const filterProps = me.getProp(`${filterDimension.id}Filters`);
                if (filterProps) {
                    memo = memo.concat(_.map(filterProps, function (filter) {
                        return {
                            filterDimension: filterDimension,
                            value: filter
                        };
                    }));
                }
                return memo;
            }, []);

            me.collection.reset(filters);
        }
    });

}, window.moment);
